module.exports = __webpack_public_path__ + "img/ZW.bf471e52.png";